import Vue from 'vue'
import GetTextPlugin from 'vue-gettext'
import translations from './translations/translations.js'
import router from './router/customer'
import store from './store/customer'
import MainComponent from './components/layout/MainComponent.vue'
import { API_ROOT } from '@/api/config'
import AuthUser from '@/classes/auth/AuthUser'
import Buefy from 'buefy'
import bugsnagClient from '@/utility/bugsnag'
import './assets/scss/app.scss'
require('./assets/sass/style.sass')

const bugsnagVue = require('bugsnag-vue')
bugsnagClient.use(bugsnagVue(Vue))

Vue.config.productionTip = false
process['API_ENDPOINT'] = `${API_ROOT}/customer`
Vue.use(GetTextPlugin, {
  availableLanguages: {
    en: 'English',
    sv: 'Svenska'
  },
  defaultLanguage: AuthUser.getLanguage() || 'sv',
  translations: translations,
  silent: true
})
Vue.use(Buefy)
Vue.filter('translate', (value) => {
  return !value ? '' : Vue.prototype.$gettext(value.toString())
})

/* eslint-disable no-new */
const app = new Vue({
  template: `<main-component id="main-customer" :navbarItems="navbarItems" :isOpen="true" />`,
  router,
  store,
  components: {
    MainComponent
  },
  data () {
    return {
      navbarItems: [
        {
          destination: '/',
          text: 'Dashboard',
          exact: true
        },
        {
          destination: '/profile',
          text: 'Customer information',
          exact: false
        },
        {
          destination: '/certificates',
          text: 'Certificates list',
          exact: true
        }
      ]
    }
  }
}).$mount('#app')

if (window.Cypress) {
  window.app = app
}
